export default __webpack_public_path__ + "static/media/search.b0de4110.svg";